import { render, staticRenderFns } from "./choiceCommand.vue?vue&type=template&id=325c6218&scoped=true"
import script from "./choiceCommand.vue?vue&type=script&lang=js"
export * from "./choiceCommand.vue?vue&type=script&lang=js"
import style0 from "./choiceCommand.vue?vue&type=style&index=0&id=325c6218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c6218",
  null
  
)

export default component.exports